import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/DeliveryBanner/index.js";
const variants = import.meta.webpackContext("/components/DeliveryBanner", { recursive: true, regExp: /\.\/__variants__\/plp\-delivery\-cutoff\-banner\/v2\/index\.js/ });
export default pointCut({ joinPoint, variants });